module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button",
    attrs: {
      "to": {
        path: '/schedule/edit/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Schedules")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "label": "Megnevezés",
      "name": "name"
    },
    on: {
      "keydownEnter": _vm.searchClick
    },
    model: {
      value: (_vm.search.name),
      callback: function($$v) {
        _vm.$set(_vm.search, "name", $$v)
      },
      expression: "search.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "button with-icon",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchClick
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("Keresés")])])]), _vm._v(" "), (_vm.schedules.length > 0) ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Schedules")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.schedules), function(schedule) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(schedule.name))]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [_c('router-link', {
      staticClass: "small-button",
      attrs: {
        "to": {
          path: '/schedule/edit/',
          query: {
            scheduleID: schedule.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    })]), _vm._v(" "), _c('a', {
      staticClass: "small-button",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.del(schedule.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-alt"
    })])], 1)])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.schedules.length > 0) ? _c('pagination', {
    attrs: {
      "showcombo": "1",
      "limit": _vm.search.limit,
      "amount": _vm.search.amount
    },
    on: {
      "pageChanged": _vm.pageChanged
    },
    model: {
      value: (_vm.search.page),
      callback: function($$v) {
        _vm.$set(_vm.search, "page", $$v)
      },
      expression: "search.page"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('HTMLFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v("Kereső")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Megnevezés")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f15ca3c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/schedules.vue
// module id = 332
// module chunks = 0